const en = {
  loading: 'Loading pages...',
  title: 'Pages',
  add: 'Add page',
  empty: 'No pages yet',
  /** The title of a new page */
  titlePlaceholder: '[Title]',
  saveFailed: 'Failed to save page',
  /** The section of the pages that have no category */
  noCategory: 'No category',
  /** A page's order, in the list */
  rowOrder: (order: number) => `Order ${order}`,
  newPage: 'New page',
  editPage: 'Edit page',
  titleLabel: 'Title',
  category: 'Category',
  categoryHint: 'Pages are grouped by category',
  newCategory: 'Type to create a new category',
  order: 'Order',
  orderHint: 'Lower numbers first',
  content: 'Content',
  contentHint: 'HTML content of the page',
  icon: 'Icon',
  iconHint: 'Small image shown in the list',
  headerImage: 'Header image',
  headerImageHint: 'Large image shown at the top of the page',
  saving: 'Saving...',
  /** Deletes the page */
  remove: 'Remove',
  removing: 'Removing...',
};

const fr: typeof en = {
  loading: 'Chargement des pages...',
  title: 'Pages',
  add: 'Ajouter une page',
  empty: 'Aucune page pour l\'instant',
  titlePlaceholder: '[Titre]',
  saveFailed: 'Impossible d\'enregistrer la page',
  noCategory: 'Sans catégorie',
  rowOrder: (order: number) => `Ordre ${order}`,
  newPage: 'Nouvelle page',
  editPage: 'Modifier la page',
  titleLabel: 'Titre',
  category: 'Catégorie',
  categoryHint: 'Les pages sont regroupées par catégorie',
  newCategory: 'Saisissez un nom pour créer une catégorie',
  order: 'Ordre',
  orderHint: 'Les plus petits numéros en premier',
  content: 'Contenu',
  contentHint: 'Contenu HTML de la page',
  icon: 'Icône',
  iconHint: 'Petite image affichée dans la liste',
  headerImage: 'Image d\'en-tête',
  headerImageHint: 'Grande image affichée en haut de la page',
  saving: 'Enregistrement...',
  remove: 'Supprimer',
  removing: 'Suppression...',
};

const messages = { en, fr };
export default messages;
